module.exports = __webpack_public_path__ + "static/1-0764717f77e1abd8daea1ce01bf039aa.jpg";